module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjE0NDguNzE2IiB2aWV3Qm94PSIwIDAgMTQ0MCAxNDQ4LjcxNiI+CiAgPHBhdGggaWQ9IlBhdGhfNzgiIGRhdGEtbmFtZT0iUGF0aCA3OCIgZD0iTTAtLjM0NlYxNDQ4LjM2OUgxNDQwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ0MCAxNDQ4LjM2OSkgcm90YXRlKDE4MCkiIGZpbGw9IiNlMzVhMmEiIG9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./assets/img/orange-bg.svg
// module id = 13
// module chunks = 0